import React, { FC, memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { AppRoutes } from 'app/config/routerConfig/types';
import { useGetRentOptionsQuery } from 'entities/RentOption';
import { useSpecialPromotionModal } from 'features/SpecialPromotion';
import EasterEN from 'shared/assets/images/EasterEN.png';
import EasterDE from 'shared/assets/images/EasterDE.png';
import EasterENMobile from 'shared/assets/images/EasterENMobile.png';
import EasterDEMobile from 'shared/assets/images/EasterDEMobile.png';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';
import { AppLanguage } from 'app/config/i18Config/types';
import i18n from 'app/config/i18Config/i18n';

export const EasterPromotionContent: FC = () => {
  const { t } = useAppTranslation('common');

  const navigate = useNavigate();

  const { data } = useGetRentOptionsQuery({ isSpecialPromotion: true });
  const { closeModal } = useSpecialPromotionModal();

  const { isDesktop } = useScreenBreakpoints();

  const goToBooking = useCallback(() => {
    navigate(data?.length ? `${AppRoutes.BOOKING}?rentOptionId=${data[0].rentOptionId}` : AppRoutes.BOOKING);
    closeModal();
  }, [closeModal, data, navigate]);

  const currentLanguage = i18n.language as AppLanguage.en | AppLanguage.de;

  type DeviceType = 'desktop' | 'mobile';

  const promotionImageMap: Record<AppLanguage.en | AppLanguage.de, Record<DeviceType, string>> = {
    [AppLanguage.en]: {
      desktop: EasterEN,
      mobile: EasterENMobile,
    },
    [AppLanguage.de]: {
      desktop: EasterDE,
      mobile: EasterDEMobile,
    },
  };

  const deviceType: DeviceType = isDesktop ? 'desktop' : 'mobile';

  const promotionImage = promotionImageMap[currentLanguage]?.[deviceType] ?? promotionImageMap[AppLanguage.en][deviceType];

  return (
    <div>
      <img className="w-full cursor-pointer" src={promotionImage} alt="Christmas promotion" onClick={goToBooking} />
    </div>
  );
};
